var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#02B4BA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1759 27.6767H16.823V25.0869C16.8543 25.088 16.8858 25.0885 16.9175 25.0885H28.1792C29.4366 25.0885 30.5253 24.2459 30.7981 23.0617L32.2885 16.5911C32.3309 16.4068 32.3524 16.2185 32.3524 16.0297C32.3524 14.6002 31.1513 13.4414 29.6696 13.4414H16.9175C16.8858 13.4414 16.8543 13.442 16.823 13.443V10.8532C16.823 10.1385 16.2436 9.55908 15.5288 9.55908H12.9406C12.2259 9.55908 11.6465 10.1385 11.6465 10.8532C11.6465 11.5679 12.2259 12.1473 12.9406 12.1473H14.2347V28.9708C14.2347 29.6856 14.8141 30.265 15.5288 30.265H27.1759C27.8906 30.265 28.47 29.6856 28.47 28.9708C28.47 28.2561 27.8906 27.6767 27.1759 27.6767ZM18.117 33.5004C18.117 34.5724 17.2479 35.4415 16.1759 35.4415C15.1038 35.4415 14.2347 34.5724 14.2347 33.5004C14.2347 32.4283 15.1038 31.5592 16.1759 31.5592C17.2479 31.5592 18.117 32.4283 18.117 33.5004ZM27.8229 35.4415C28.895 35.4415 29.7641 34.5724 29.7641 33.5004C29.7641 32.4283 28.895 31.5592 27.8229 31.5592C26.7508 31.5592 25.8817 32.4283 25.8817 33.5004C25.8817 34.5724 26.7508 35.4415 27.8229 35.4415ZM16.8229 22.5004V16.0298H29.7641L28.2516 22.5004H16.8229Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.1974c8dd2fc4794a284708025ef730b4.svg";
export { ForwardRef as ReactComponent };